/* eslint-disable require-jsdoc */
/* eslint-disable no-undef */

import {InfoWindow} from '../InfoWindow/infowindow';
import {stylers} from '../map/styles/stylers';
import { pApiBase, eventTag } from '../../../../config';
import { futureDates } from '../../../../carousel-react/src/utils/date';
import { isValid } from '../../../../utils/validate';
function CurrDateQuery(date) {
  // console.log(date);
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0'); // January is 0!
  const yyyy = date.getFullYear();
  const dateStr = yyyy + '-' + mm + '-' + dd;
  // console.log(dateStr);
  return dateStr;

}
export function getQueryStr(aMap) {
  let genreStr = '';
  if(aMap.genre){
    genreStr = getActiveGenres(aMap.genre);
   }
  let distStr, minStr, maxStr;
  distStr = aMap.distance ? String(aMap.distance) : window.powersearchUserSettings.powersearchBarOpts.distanceOpts.defaultDistance;
  minStr = aMap.minDate ? String(aMap.minDate) : CurrDateQuery(new Date());
  maxStr = aMap.maxDate ? String(aMap.maxDate) 
  : futureDates(window.powersearchUserSettings.defaultTimeframeForSearch);

  let queryStr = `${pApiBase}/map-markers?distance=${distStr}&zoom=${aMap.zoom}&lat=${aMap.loc.lat}&lon=${aMap.loc.lng}&min_date=${minStr}&max_date=${maxStr}&genre=${genreStr}`
  if (isValid(aMap.subscriber)) {
    queryStr += `&subscriber=${aMap.subscriber}`;
  }
  if (eventTag !== '' ) {
    queryStr += `&tag=${eventTag}`;
  }
  return queryStr;
}

function getActiveGenres(genre) {
  let buildGenreStr = '';

  for(const key of Object.keys(genre)){
    if (genre[key] == true) {
      buildGenreStr += String(key);
      if(buildGenreStr.length > 1){
        buildGenreStr += ','
      }
    }
  }

  return buildGenreStr.slice(0,-1);
}
let mapMarker;
let infoWindow;
let globalinfo = undefined;
let currentLocationFlag = true;
export function addVenues(points, aMap) {
  const response = points.results;
  if(aMap.markers !== []){
    deleteMarkers(aMap.map);
  }
  for (const i in response){
    const location = new google.maps.LatLng(response[i].lat, response[i].lon);
  if (response[i].title != undefined) {
    if (response[i].hasEvents == 0) {
      mapMarker = new google.maps.Marker({
        position: location,
        title: response[i].title,
        map: aMap.map,
        id: response.venueGuid,
        zIndex: 1,
        icon: stylers.icons.hasnoevents,
      });
    } else {
      mapMarker = new google.maps.Marker({
        position: location,
        title: response[i].title,
        map: aMap.map,
        id: response.venueGuid,
        zIndex: 2,
        icon: stylers.icons.hasnoeventsv6,
      });
    }
  } else {
    const clusterLoc = new google.maps.LatLng(response[i].lat, response[i].lng);
    mapMarker = new google.maps.Marker({
      position: clusterLoc,
      map: aMap.map,
      id: response[i].id,
      zIndex: 2,
      icon: stylers.icons.hearbyEvents,
    });
  }
  aMap.markers.push(mapMarker);
  mapMarker.setMap(aMap.map);
  if (response[i].title != undefined) {
    createVenueInfo(response[i], mapMarker, aMap.map);
  }
}
if(currentLocationFlag){
  const current_location = {
    position: aMap.loc,
    map: aMap.map,
    id: 1,
    zIndex: 1,
    icon: 'https://www.robotwoods.com/dev/misc/bluecircle.png',
  };
  const currentLocMarker = new google.maps.Marker(current_location);
  currentLocMarker.setMap(aMap.map);
  currentLocationFlag = false;
}
}
export function setMapOnAll(map) {
  for (let i = 0; i < aMap.markers.length; i++) {
    aMap.markers[i].setMap(map);
  }
  aMap.markers = [];
}

// Deletes all markers in the array by removing references to them.
export function deleteMarkers(map) {
  setMapOnAll(null);
  map.markers = [];
}
function createVenueInfo(ven, marker, map) {
  marker.addListener('click', () => {
   // google.maps.event.clearListeners(map, 'idle');
    if (globalinfo == undefined) {
      //A4Map
      infoWindow = new InfoWindow(marker, ven, map);
      globalinfo = infoWindow;
      infoWindow.createInfoWindow();
    } else {
      infoWindow.marker = marker;
      infoWindow.venue = ven;
      infoWindow.map = map;
      infoWindow.createInfoWindow();
    }
  });
}
